import { Tile, Row, Empty } from "./Tile";
import { clock } from "../../lib/dash";

export const GateHistoryTile = ({ a, gated, index }) => (
  <Tile id="gate-history" index={index} kicker="SITE_GATE secret · audited" title="Site gate">
    <Row label="Now" testid="gate-now" value={gated ? "Gated: invite only (partners, staff, admin, owner)" : "Open: customers sign in as before"} />
    <p className="mb-1 mt-3 text-[11px] font-semibold uppercase tracking-wider text-muted-foreground">Switch history</p>
    {a.gate_history.length === 0 ? <Empty testid="gate-history-empty">No switch recorded yet.</Empty> : (
      <ul data-testid="gate-history" className="min-h-0 flex-1 overflow-y-auto pr-1">
        {a.gate_history.map((g) => (
          <li key={g.at} className="flex justify-between gap-2 border-b border-border/60 py-1.5 text-[13px] last:border-0">
            <span className="font-medium">{g.action === "site_gate.on" ? "Switched ON (gated)" : "Switched OFF (open)"}</span>
            <span className="text-muted-foreground">{g.meta?.environment || ""} · {clock(g.at)}</span>
          </li>
        ))}
      </ul>
    )}
  </Tile>
);
